<header role="banner" class="topo-pmv">
  <div class="container-fluid"> </div>
</header>
<header class="topo-cabecalho">
  <div class="container-fluid">
    <div class="container">
      <div class="row">
        <ng-container *ngTemplateOutlet="headerTemplate || defaultTemplate"></ng-container>
      </div>
    </div>
  </div>
  <pmv-navigation *ngIf="isUserLoggedIn"></pmv-navigation>
</header>
<ng-template #defaultTemplate>
  <div [ngClass]="{'col-sm-7': bigTitle, 'col-sm-5': !bigTitle}" class="col-xs-11 title">
    <h1>
      <a [routerLink]="['home']">{{ title }}</a>
    </h1>
    <p class="label-versao">{{ version }}</p>
  </div>
  <div [ngClass]="{'col-sm-1': bigTitle, 'col-sm-3': !bigTitle}" class="col-xs-12">
    <pmv-idle-timer *ngIf="isUserLoggedIn && timeLogout" [timeLogout]="timeLogout"></pmv-idle-timer>
  </div>
  <div class="col-sm-4 col-xs-12" *ngIf="isUserLoggedIn">
    <ng-content></ng-content>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbj.html